// LIVE
export const BetmateApiBaseUrl = "https://6jbemon44b.execute-api.eu-west-2.amazonaws.com"; 

// DEV
// export const BetmateApiBaseUrl = "https://pxhkycca58.execute-api.eu-west-2.amazonaws.com";